import { ecboClient, getHeaderLocale } from 'lib/axios'

import type {
  FetchNearbySpacesParams,
  NearbySpacesResponse,
} from 'features/space/types/nearbySpace'

const API_NEARBY_SPACES = '/api/web/spaces/nearby'

export const fetchNearbySpaces = async (params: FetchNearbySpacesParams) => {
  try {
    const response = await ecboClient.get<NearbySpacesResponse>(API_NEARBY_SPACES, {
      params: {
        latitude: params.latitude,
        longitude: params.longitude,
        page: params.page,
        page_size: params.page_size,
        ...(params.prefecture_id !== undefined ? { prefecture_id: params.prefecture_id } : {}),
        ...(params.facility_id !== undefined ? { facility_id: params.facility_id } : {}),
        ...(params.filter_condition ? { filter_condition: params.filter_condition } : {}),
      },
      headers: { 'Accept-Language': getHeaderLocale(params.locale) },
    })

    return {
      isOk: true as const,
      data: response.data,
    }
  } catch (error) {
    const status = error?.response?.status
    return {
      isOk: false as const,
      data: null,
      isNotFound: status === 404,
    }
  }
}
